import { ExperimentType } from 'ha/modules/Experiments';

const Experiments: { [name: string]: ExperimentType } = {
  HA5572: {
    name: '[HA-5572] Listing page fixed footer',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  MON1204: {
    name: '[MON-1204] new book pages',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
  HA5815: {
    name: '[HA-5815] Set up experiment metrics mobile single tabbing',
    variants: ['A', 'B'],
    weights: [50, 50],
  },
};

export default Experiments;
